import React, { useState, useEffect } from "react";
import { db } from "../utils/firebaseStorage";
import { auth } from "../../firebase";
import { Sidebar } from "../sidebar/sidebar";
import { useSidebar } from "../context/SidebarContext";
import { useNavigate } from "react-router-dom";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
  getDoc,
  setDoc,
} from "firebase/firestore";

const InternshipAdmin = () => {
  const [formData, setFormData] = useState({
    companyName: "",
    jobRole: "",
    salaryRange: "",
    experience: "",
    batchYears: "",
    jobType: "",
    employmentType: "",
    location: "",
    imageUrl: "",
    applyLink: "",
    skills: "",
    responsibilities: "",
    description: "",
    postDate: new Date().toISOString(),
  });

  const [internships, setInternships] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const { isOpen } = useSidebar();
  const [adminCredentials, setAdminCredentials] = useState({
    username: "",
    password: "",
  });
  const [editId, setEditId] = useState(null);
  const [activeTab, setActiveTab] = useState("internships");
  const [featureFlags, setFeatureFlags] = useState({
    dashboard: true,
    careerPath: true,
    learn: true,
    interviewPractice: true,
    internships: true,
  });

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        if (user.email && process.env.REACT_APP_ADMIN_EMAILS?.split(',').includes(user.email)) {
          setIsAdmin(true);
        } else {
          navigate(`/dashboard/${user.uid}`);
        }
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    const fetchInternships = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "internships"));
        const fetchedInternships = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        // Sort by postDate in descending order (latest first)
        const sortedInternships = fetchedInternships.sort(
          (a, b) => new Date(b.postDate) - new Date(a.postDate),
        );

        setInternships(sortedInternships);
      } catch (error) {
        console.error("Error fetching internships: ", error);
      }
    };

    const fetchFeatureFlags = async () => {
      try {
        const docRef = doc(db, "settings", "featureFlags");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setFeatureFlags((prev) => ({ ...prev, ...docSnap.data() }));
        }
      } catch (error) {
        console.error("Error fetching feature flags: ", error);
      }
    };

    fetchInternships();
    fetchFeatureFlags();
  }, []);

  const handleToggleFlag = async (key) => {
    const newValue = !featureFlags[key];
    const newFlags = { ...featureFlags, [key]: newValue };
    setFeatureFlags(newFlags);
    try {
      await updateDoc(doc(db, "settings", "featureFlags"), newFlags);
    } catch (error) {
      try {
        await setDoc(doc(db, "settings", "featureFlags"), newFlags);
      } catch (err) {
        console.error("Error setting feature flags: ", err);
      }
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (
      adminCredentials.username ===
        ("admin") &&
      adminCredentials.password ===
        ("admin123")
    ) {
      setIsAdmin(true);
    } else {
      alert("Invalid credentials");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const internshipData = {
        ...formData,
        skills: formData.skills.split(",").map((skill) => skill.trim()),
        responsibilities: formData.responsibilities
          .split(",")
          .map((resp) => resp.trim()),
      };

      if (editId) {
        await updateDoc(doc(db, "internships", editId), internshipData);
        alert("Internship updated successfully!");
        setInternships(
          internships.map((item) =>
            item.id === editId ? { id: editId, ...internshipData } : item,
          ),
        );
        setEditId(null);
      } else {
        const docRef = await addDoc(
          collection(db, "internships"),
          internshipData,
        );
        alert("Internship added successfully!");
        setInternships([...internships, { id: docRef.id, ...internshipData }]);
      }

      const deadline = new Date();
      deadline.setDate(deadline.getDate() + 7);
      const formattedDeadline = deadline.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      const profilesSnapshot = await getDocs(collection(db, "profiles"));
      const recipients = profilesSnapshot.docs
        .map((doc) => doc.data())
        .filter((profile) => profile.email && profile.name)
        .map((profile) => ({
          name: profile.name,
          email: profile.email,
        }));

      const notificationPayload = {
        email_config: {
          subject: `Exciting Opportunity: ${internshipData.jobRole} at ${internshipData.companyName}`,
        },
        job_details: {
          role: internshipData.jobRole,
          location: internshipData.location,
          state: internshipData.location.split(",")[1]?.trim() || "",
          salary_range: internshipData.salaryRange,
          experience: internshipData.experience,
          batch_years: internshipData.batchYears,
          job_type: internshipData.jobType,
          employment_type: internshipData.employmentType,
          deadline: formattedDeadline,
          apply_url: internshipData.applyLink,
        },
        company_info: {
          name: internshipData.companyName,
          description:
            internshipData.description ||
            "Exciting opportunity at a great company!",
        },
        skills: internshipData.skills,
        recipients,
      };

      try {
        const response = await fetch(
          "https://devhub-k9dg.onrender.com/api/send-job-notification/",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(notificationPayload),
          },
        );

        if (!response.ok) throw new Error("Notification failed");
        const result = await response.json();
        console.log("Notification sent:", result);
      } catch (notifyErr) {
        console.error("Notification error:", notifyErr);
      }

      // Reset form
      setFormData({
        companyName: "",
        jobRole: "",
        salaryRange: "",
        experience: "",
        batchYears: "",
        jobType: "",
        employmentType: "",
        location: "",
        imageUrl: "",
        applyLink: "",
        skills: "",
        responsibilities: "",
        description: "",
        postDate: new Date().toISOString(),
      });
    } catch (error) {
      console.error("Error submitting internship: ", error);
      alert("Failed to submit internship");
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "internships", id));
      alert("Internship deleted successfully!");
      setInternships(internships.filter((internship) => internship.id !== id));
    } catch (error) {
      console.error("Error deleting internship:", error);
      alert("Failed to delete internship");
    }
  };

  const handleEdit = (internship) => {
    setEditId(internship.id);
    setFormData({
      ...internship,
      skills: internship.skills.join(", "),
      responsibilities: internship.responsibilities.join(", "),
    });
  };

  // Login Form
  if (!isAdmin) {
    return (
      <div className="flex bg-[#e9effe] min-h-screen">
        <Sidebar />
        <div
          className="flex-1 overflow-auto bg-blue-50 mt-14 sm:mt-0 transition-all duration-300 flex items-center justify-center px-4"
          style={{ marginLeft: isOpen ? "256px" : "64px" }}
        >
          <div className="bg-white shadow-md rounded-lg p-8 max-w-md w-full">
          <h2 className="text-2xl font-bold text-center mb-6">Admin Login</h2>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-gray-700 font-bold mb-2">
                Username
              </label>
              <input
                type="text"
                value={adminCredentials.username}
                onChange={(e) =>
                  setAdminCredentials((prev) => ({
                    ...prev,
                    username: e.target.value,
                  }))
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Enter username"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 font-bold mb-2">
                Password
              </label>
              <input
                type="password"
                value={adminCredentials.password}
                onChange={(e) =>
                  setAdminCredentials((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }))
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="Enter password"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-blue-500 text-white py-2 rounded-md"
            >
              Login
            </button>
          </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex bg-[#e9effe] min-h-screen">
      <Sidebar />
      <div
        className="flex-1 overflow-auto bg-blue-50 mt-14 sm:mt-0 transition-all duration-300 p-8"
        style={{ marginLeft: isOpen ? "256px" : "64px" }}
      >
        <div className="container mx-auto mb-8">
          <div className="flex space-x-4 bg-white p-4 rounded-lg shadow-md w-fit">
            <button
              onClick={() => setActiveTab("internships")}
              className={`px-4 py-2 rounded-md font-bold transition-colors ${activeTab === "internships" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
            >
              Internships
            </button>
            <button
              onClick={() => setActiveTab("featureFlags")}
              className={`px-4 py-2 rounded-md font-bold transition-colors ${activeTab === "featureFlags" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
            >
              Feature Flags
            </button>
          </div>
        </div>

        {activeTab === "featureFlags" ? (
          <div className="container mx-auto max-w-3xl">
            <div className="bg-white shadow-2xl rounded-xl p-8 border-t-4 border-purple-500">
              <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">
                Manage Sidebar Features
              </h1>
              <div className="space-y-6">
                {Object.keys(featureFlags).map((flag) => (
                  <div key={flag} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg shadow-sm border border-gray-200">
                    <span className="text-lg font-medium text-gray-700 capitalize">
                      {flag.replace(/([A-Z])/g, ' $1').trim()}
                    </span>
                    <button
                      onClick={() => handleToggleFlag(flag)}
                      className={`relative inline-flex items-center h-8 rounded-full w-14 transition-colors focus:outline-none ${featureFlags[flag] ? 'bg-green-500' : 'bg-gray-300'}`}
                    >
                      <span
                        className={`inline-block w-6 h-6 transform bg-white rounded-full transition-transform ${featureFlags[flag] ? 'translate-x-7' : 'translate-x-1'}`}
                      />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
        <div className="container mx-auto grid md:grid-cols-2 gap-8">
          {/* Form Section */}
        <div className="bg-white shadow-2xl rounded-xl p-8 border-t-4 border-blue-500">
          <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">
            Add Internship
          </h1>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  Company Name
                </label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  required
                />
              </div>

              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  Job Role
                </label>
                <input
                  type="text"
                  name="jobRole"
                  value={formData.jobRole}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  Salary Range
                </label>
                <input
                  type="text"
                  name="salaryRange"
                  value={formData.salaryRange}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  Experience Required
                </label>
                <input
                  type="text"
                  name="experience"
                  value={formData.experience}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  Batch Years
                </label>
                <input
                  type="text"
                  name="batchYears"
                  value={formData.batchYears}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  placeholder="2024, 2025, 2026"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  Job Type
                </label>
                <input
                  type="text"
                  name="jobType"
                  value={formData.jobType}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  Employment Type
                </label>
                <input
                  type="text"
                  name="employmentType"
                  value={formData.employmentType}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  Location
                </label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  Company Logo URL
                </label>
                <input
                  type="url"
                  name="imageUrl"
                  value={formData.imageUrl}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
            </div>

            <div>
              <label className="block text-gray-700 font-bold mb-2">
                Apply Link
              </label>
              <input
                type="url"
                name="applyLink"
                value={formData.applyLink}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 font-bold mb-2">
                Skills (comma-separated)
              </label>
              <textarea
                name="skills"
                value={formData.skills}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                rows="3"
                placeholder="React, Node.js, JavaScript"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-bold mb-2">
                Job Description
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                rows="5"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-green-500 text-white py-3 rounded-md hover:bg-green-600 transition duration-300"
            >
              Add Internship
            </button>
          </form>
        </div>

        {/* Internships List Section */}
        <div className="bg-white shadow-2xl rounded-xl p-8 border-t-4 border-green-500">
          <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">
            Internships
          </h2>
          {internships.length > 0 ? (
            <div className="space-y-4">
              {internships.map((internship) => (
                <div
                  key={internship.id}
                  className="bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md transition duration-300 border border-gray-200 flex justify-between items-center"
                >
                  <div>
                    <h3 className="text-lg font-bold text-gray-800">
                      {internship.companyName} - {internship.jobRole}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {internship.location} | {internship.salaryRange}
                    </p>
                  </div>
                  <div className="flex space-x-2">
                    <button
                      onClick={() => handleEdit(internship)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded-md hover:bg-yellow-600 transition duration-300 transform hover:scale-105"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(internship.id)}
                      className="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600 transition duration-300 transform hover:scale-105"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-gray-600">
              No internships available.
            </p>
          )}
        </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default InternshipAdmin;
